import { render, staticRenderFns } from "./Awardreview.vue?vue&type=template&id=19bfafb9&scoped=true"
import script from "./Awardreview.vue?vue&type=script&lang=js"
export * from "./Awardreview.vue?vue&type=script&lang=js"
import style0 from "./Awardreview.vue?vue&type=style&index=0&id=19bfafb9&prod&lang=css"
import style1 from "./Awardreview.vue?vue&type=style&index=1&id=19bfafb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfafb9",
  null
  
)

export default component.exports